import t from "react";
import { mintelGray400 as l, mintelGray500 as m, mintelWhite as s, mintelGray100 as n } from "mintel-tokens";
import { u as i } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as f } from "./index-Dd-4N6BE.es.js";
import './FooterLabel.css';const p = "FooterLabel-module__footerLabel___B9y26", c = {
  footerLabel: p
}, b = ({
  children: r,
  secondary: o = !1
}) => {
  const a = i();
  let e = o ? l : m;
  return a && (o ? e = s : e = n), /* @__PURE__ */ t.createElement("span", { className: c.footerLabel }, /* @__PURE__ */ t.createElement(f.Body2, { color: e, responsive: !0 }, r));
};
b.displayName = "FooterLabel";
export {
  b as F
};
